import React from 'react';
import { Tooltip } from 'antd';
import { CheckCircleFilled, CloseCircleFilled, ExclamationCircleFilled, SyncOutlined } from '@ant-design/icons';
import { Typography } from 'antd';

const { Text } = Typography;

/**
 * PreflightStatusIcon component that displays preflight status with simple hover tooltips
 * @param {Object} source - Source object containing preflight information
 * @param {string} source.preflight_state - State of preflight (success, error, etc.)
 * @param {string} source.preflight_error_type - Type of preflight error (fatal, warning)
 * @param {string} source.preflight_id - ID of the preflight for fetching details
 * @param {string} source.attribute_state - State of attribute collection
 */
export const PreflightStatusIcon = ({ source }) => {
    const { preflight_state, preflight_error_type, attribute_state, preflight_id } = source;

    // Render the appropriate icon based on preflight state
    const renderIcon = () => {
        if (preflight_state === 'success') {
            return (
                <Tooltip title="Ready">
                    <CheckCircleFilled style={{ color: '#52c41a', fontSize: '18px' }} />
                </Tooltip>
            );
        } else if (preflight_state === 'error') {
            const tooltipText = preflight_error_type === 'fatal' ? 'Click to view errors' : 'Click to view warnings';

            if (preflight_error_type === 'fatal') {
                return (
                    <Tooltip title={tooltipText}>
                        <CloseCircleFilled style={{ color: '#ff4d4f', fontSize: '18px', cursor: 'pointer' }} />
                    </Tooltip>
                );
            }
            return (
                <Tooltip title={tooltipText}>
                    <ExclamationCircleFilled style={{ color: '#faad14', fontSize: '18px', cursor: 'pointer' }} />
                </Tooltip>
            );
        } else if (attribute_state === 'error') {
            return (
                <Tooltip title="Attribute Error">
                    <CloseCircleFilled style={{ color: '#ff4d4f', fontSize: '18px' }} />
                </Tooltip>
            );
        } else if (attribute_state === 'running') {
            return (
                <Tooltip title="Pending">
                    <SyncOutlined spin style={{ color: '#1890ff', fontSize: '18px' }} />
                </Tooltip>
            );
        }

        return (
            <Text className={'font-size-12'} type={'secondary'}>
                Not inspected
            </Text>
        );
    };

    return renderIcon();
};
